import { uiBase } from '../env/constants'

export const boURL = uiBase +'bo'
